const key: string = "AIzaSyDoG4eWlZpyV4bUijIbWZWEgwuw60f6fEE";

export default key;
